export class GameThemeService<A extends string> {
  private gameColors = new Map<A, string>();

  constructor(
    readonly defaultFontFamily: string,
    colorKeys: A[],
  ) {
    this.gameColors = new Map(colorKeys.map((key) => [key, getCSSVariable(key)]));
  }

  public getNumericalRGB(key: A): number {
    const hexColor = this.getHexColor(key);
    return parseInt(hexColor.replace('#', '').slice(0, 6), 16);
  }

  public getNumericalAlpha(key: A): number {
    const hexColor = this.getHexColor(key);
    const hexAlpha = hexColor.replace('#', '').slice(6, 8);
    if (!hexAlpha) {
      return 1;
    }
    return parseInt(hexAlpha, 16) / 255;
  }

  public getHexColor(key: A): string {
    const hexColor = this.gameColors.get(key);
    if (!hexColor) {
      console.error(`Color for key "${key}" not found in gameColors.`);
    }
    return hexColor ?? '';
  }
}

function getCSSVariable(key: string): string {
  // Get from the body for page-specific styles (e.g., dynamic themes)
  const value = getComputedStyle(document.body).getPropertyValue(key).trim();

  // Resolve if the value is another CSS variable (e.g., var(--indigo-900))
  if (value.startsWith('var(')) {
    const match = value.match(/var\((--[^)]+)\)/);
    if (match) {
      // Extract and recursively resolve
      return getCSSVariable(match[1]);
    }
  }

  return value;
}
